import React, { Component } from "react";
import E from "wangeditor";

class Wangeditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorContent: ""
    }
    this.myRefOne = React.createRef();
  }
  
  componentDidMount() {
    const {menus}=this.props;
    const elem = this.myRefOne;
    this.editor = new E(elem);
    // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
    this.editor.config.onchange = html => {
      this.setState({
        editorContent: html
      });
      this.props.saveEditor && this.props.saveEditor(html);
    }
    this.editor.config.onblur = html => {
      this.props.onBlurEditor && this.props.onBlurEditor(html);
    }
    this.editor.config.uploadImgMaxSize = 1 * 1024 * 1024 // 限制图片大小为1M
    this.editor.config.uploadImgShowBase64 = true; // 可使用 base64 格式保存图片。即，可选择本地图片，编辑器用 base64 格式显示图片。
    if(menus) this.editor.config.menus=[...menus];
    
    this.editor.create();
    this.props.disabled && this.editor.disable();
    this.editor.txt.html(this.props.initData ? this.props.initData : '');
   
  }
  render() {
    return (
      <div className="editor">
        {/* 将生成编辑器 */}
        <div
          ref={(ref) => this.myRefOne = ref}
          style={{
            textAlign: "left"
          }}
        >
        </div>
      </div>
    );
  }
}
 
export default Wangeditor;
